<template>
	<div>
		<RightPanel></RightPanel>
		<el-dropdown trigger="click" >
			<div class="avatar-wrapper">
				<el-avatar shape="circle" :size="40" :src="avatar"></el-avatar>
				<div class="user-name">{{userInfo.userType?userInfo.nickname:userInfo.qyName}}<i class="el-icon-caret-bottom" /></div>
			</div>
			<el-dropdown-menu slot="dropdown">
				<router-link to="/user/profile">
					<el-dropdown-item>个人中心</el-dropdown-item>
				</router-link>
				<el-dropdown-item>
					<span @click="setting = true">布局设置</span>
				</el-dropdown-item>
				<el-dropdown-item divided @click.native="logout">
					退出登录
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
	</div>
</template>

<script>
	import RightPanel from '@/components/RightPanel'
	export default {
		data() {
			return {

			};
		},
		components: {
			RightPanel
		},
		computed: {
			setting: {
				get() {
					return this.$store.state.settings.showSettings
				},
				set(val) {
					this.$store.dispatch('settings/changeSetting', {
						key: 'showSettings',
						value: val
					})
				}
			},
			avatar() {
				return process.env.VUE_APP_BASE_API + this.$store.getters['user/avatar'];
			},
			userInfo(){
				return this.$store.getters['user/user'];
			},
		},
		created(){
			console.log(this.userInfo)
		},
		methods: {
			logout() {
				let _this = this;
				_this.confirm({
					text: '确定注销并退出系统吗？',
					tip: '提示',
					type: '',
					fn: function() {
						_this.$store.dispatch('user/LogOut').then(() => {
							location.reload();
						})
					}
				});
			}
		}

	}
</script>

<style lang="scss">
	.avatar-wrapper {
		margin-top: 5px;
		position: relative;
		display: flex;
		flex-direction: row;
		align-items: center;

		.user-name {
			padding: 0px 5px;
		}

		.user-avatar {
			cursor: pointer;
			width: 40px;
			height: 40px;
			border-radius: 10px;
		}
	}
</style>
